import React from 'react';
import { AttendanceStatus } from '../../types/event';
import type { EventTravel } from '../../types/travel';
import PlayerTravelChoice from './PlayerTravelChoice';
import MyCarPanel from './MyCarPanel';
import { useTravelResponder } from './useTravelResponder';

interface TravelRespondPanelProps {
  travel: EventTravel;
  onChange: (travel: EventTravel) => void;
}

/**
 * A szülő (vagy a játékos) jelzései az utazáshoz, gyerekenként: fuvar kell
 * (és hol száll be), saját maga megy, vagy autóval mennek - ilyenkor az autó
 * is felajánlható, és abba a csapatból mások is beültethetők.
 */
const TravelRespondPanel: React.FC<TravelRespondPanelProps> = ({ travel, onChange }) => {
  const responder = useTravelResponder(travel, onChange);

  return (
    <div className="space-y-3">
      {(travel.myPlayers ?? []).map((player) =>
        player.response === AttendanceStatus.NotAttending ? (
          <div key={player.playerId} className="rounded-lg border border-gray-200 bg-white p-3 text-sm text-gray-500">
            <span className="font-semibold text-gray-700">{player.name}</span> nem jön, így nem is utazik.
          </div>
        ) : (
          <div key={player.playerId} className="rounded-lg border border-gray-200 bg-white p-3">
            <p className="mb-2 text-sm font-semibold text-gray-900">Hogyan jut el {player.name}?</p>
            <PlayerTravelChoice
              travel={travel}
              playerId={player.playerId}
              busy={responder.busy}
              onSet={(request) => responder.setPlayer(player.playerId, request)}
              onChooseCar={() => responder.chooseCar(player.playerId)}
              carPending={responder.pendingCarFor === player.playerId}
              onCancelCar={responder.cancelPendingCar}
            />
          </div>
        )
      )}

      <MyCarPanel travel={travel} responder={responder} />
    </div>
  );
};

export default TravelRespondPanel;
